import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { useLang } from "@/contexts/LanguageContext";
import { FAQ as FAQIDS } from "@/constants/testIds";

const FAQ = () => {
  const { t } = useLang();

  return (
    <section id="faq" data-testid={FAQIDS.root} className="section-pad bg-[#F3F3EF]">
      <div className="container-cust grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <p className="eyebrow mb-5">
            <span className="eyebrow-line"></span>
            {t.faq.eyebrow}
          </p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#1A2421] leading-tight">
            {t.faq.title}
          </h2>
        </div>

        <div className="lg:col-span-7">
          <Accordion type="single" collapsible className="w-full">
            {t.faq.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={FAQIDS.item(i)}
                className="border-b border-[#E2E2DB] py-2"
              >
                <AccordionTrigger className="text-left font-serif-display text-lg md:text-xl text-[#1A2421] hover:text-[#0E5A4E] hover:no-underline">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#4A5D58] text-base leading-relaxed pt-2">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
